import * as React from "react";

export interface ConfirmationModalProps {
    toggleModal: (flag: boolean) => void,
    onConfirm: () => void,
    onCancel: () => void,
    title: string,
    message: string,
    primaryActionText: string
    secondaryActionText: string,
    shouldShowAttentionIcon?: boolean;
}

export default class ConfirmationModal extends React.Component<ConfirmationModalProps> {

    preventModalClose = (event: any) => {
        event.stopPropagation();
    };

    onConfirm = (event: any) => {
        event.stopPropagation();
        this.props.toggleModal(false)
        this.props.onConfirm()
    }

    onCancel = (event: any) => {
        event.stopPropagation();
        this.props.toggleModal(false)
        this.props.onCancel()
    }

    render() {
        return (
            <div className={"prescription-successful-save-container"} onClick={this.preventModalClose}>
                <div className="prescription-save-successful-label">
                    {this.props.shouldShowAttentionIcon &&
                        <img src="/images/icons/attention-icon.svg" aria-hidden="true" className="alert-icon"/>
                    }
                    {this.props.title}
                </div>
                <div className="patient-info-container">
                    {this.props.message}
                </div>
                <div className="save-button collapsible-card button-container">
                    <input className="card-primary-action with-border" type="button" value={this.props.secondaryActionText} onClick={this.onCancel} />
                    <input className="card-primary-action proceed-to-case-summary-button" type="button" value={this.props.primaryActionText} onClick={this.onConfirm} />
                </div>
            </div>
        )
    }
}
